import _ToolBar from '../ToolBar.jsx'
import MenuButtonAiAgent from '../menuButtons/MenuButtonAiAgent.jsx'
import MenuButtonEdit from '../menuButtons/MenuButtonEdit.jsx'
import MenuButtonInsertNode from '../menuButtons/MenuButtonInsertNode.jsx'
import MenuButtonInsertProducts from '../menuButtons/MenuButtonInsertProducts.jsx'
import MenuButtonPublishProduct from '../ProductMap/ToolBar/MenuButtonPublishProduct.jsx'
import MenuButtonPushProduct from '../ProductMap/ToolBar/MenuButtonPushProduct.jsx'
import MenuButtonReviseProduct from '../ProductMap/ToolBar/MenuButtonReviseProduct.jsx'
import MenuButtonMap from './MenuButtonMap.jsx'

export default function ToolBar(props) {
    return (
        <_ToolBar {...props}>
            <div></div>

            <div>
                <MenuButtonMap />
                <MenuButtonEdit />
                <MenuButtonInsertNode type="common" />
                <MenuButtonInsertNode type="concept" />
                <MenuButtonInsertNode type="product" />
                <MenuButtonInsertProducts />
                <MenuButtonPushProduct />
                <MenuButtonPublishProduct />
                <MenuButtonReviseProduct />
            </div>

            <div>
                <MenuButtonAiAgent />
            </div>
        </_ToolBar>
    )
}
